import appointmentActions from 'features/appointment/services/actions';
import appointmentApis from 'features/appointment/services/apis';
import appointmentSelectors from 'features/appointment/services/selectors';
import { get } from 'lodash';
import React from 'react';
import { useDispatch } from 'react-redux';
import { useSetLoadingPage } from 'services/UI/LoadingPage';
import { IResponseDataBody } from 'services/response';
import styled from 'styled-components';
import toast from 'utils/toast';
import StaffPickerManager from 'widgets/Staff/StaffPicker';
import ic_on_hold from './icons/ic_on_hold.svg';
type Props = {
  staffId?: string;
  appointmentId?: string;
};
const ButtonChangeOnHold = ({ staffId, appointmentId }: Props) => {
  const dispatch = useDispatch();
  const staffListStore = appointmentSelectors.getListStaffAvailableBooking();
  const setLoadingPage = useSetLoadingPage();
  const params = appointmentSelectors.paramsMasterData();
  const onChangeOnHold = async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    if (!appointmentId || !staffId) return;
    try {
      const staff = await StaffPickerManager.open({ title: 'Assign Staff', staffIds: [staffId], staffs: staffListStore, noneSearch: true });
      if (!staff) return;

      setLoadingPage(true);
      const res: IResponseDataBody<any> = await appointmentApis.updateStaffMultipleAppointment({
        appointmentId,
        staffId: staff.id,
      });

      if (res.data.data) {
        dispatch(appointmentActions.initData(params.date));
      }
    } catch (error) {
      const msg = get(error, 'response.data.message');
      toast.error(msg || 'Assign staff failed');
    } finally {
      setLoadingPage(false);
    }
  };
  if (!appointmentId) return null;

  return (
    <Container type='button' onClick={onChangeOnHold}>
      <img src={ic_on_hold} alt="ic_on_hold" style={{ width: 25, height: 25 }} />
    </Container>
  );
};

export default ButtonChangeOnHold;

const Container = styled.button`
border-radius: 8px;
background: #0DA472;
box-shadow: 0 2px 4px 0 rgba(44, 35, 66, 0.40), 0 4px 8px -3px rgba(45, 35, 66, 0.30), 0 -3px 0 0 #03704C inset;
display: flex;
width: 40px;
height: 40px;
padding: 8px 4px;
flex-direction: column;
justify-content: center;
align-items: center;
gap: 4px;
`;